import script from "./Job.vue?vue&type=script&setup=true&lang=js"
export * from "./Job.vue?vue&type=script&setup=true&lang=js"

import "./Job.vue?vue&type=style&index=0&id=d2224920&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/aos/aos-ats-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2224920"]])

export default __exports__